import React, { forwardRef, useCallback, useEffect, useState } from 'react';
import { ComponentProps, TabsContainerRef } from './Tabs.types';
import Tab from './Tab';
import StyledTabs from './Tabs.styled';

const Tabs = forwardRef<TabsContainerRef, ComponentProps>(
  (
    {
      activeTab = 0,
      mode = 'primary',
      hasBorder = true,
      justifyTabs = 'flex-start',
      tabWidthPerc = 100,
      onChange,
      scrollable = false,
      hideScrollbar = false,
      setActiveTabOnChange = true,
      config,
      children,
    },
    ref,
  ) => {
    const [activeTabNumber, setActiveTabNumber] = useState<number>(activeTab);
    const tabPanelsCount = React.Children.count(children);

    const handleChange = (value: number) => () => {
      if (setActiveTabOnChange) {
        setActiveTabNumber(value);
      }

      if (onChange) {
        onChange(value);
      }
    };

    useEffect(() => {
      setActiveTabNumber(activeTab);
    }, [activeTab]);

    const getTabPanel = useCallback(
      (activeTabNumber) => {
        return React.Children.toArray(children)[activeTabNumber];
      },
      [children],
    );

    return (
      <>
        <StyledTabs
          hasBorder={hasBorder}
          justifyTabs={justifyTabs}
          scrollable={scrollable}
          ref={ref}
          hideScrollbar={hideScrollbar}>
          {config.map((tabConfig, index: number) => {
            const { label, isDisabled, id } = tabConfig;

            return (
              <Tab
                key={id}
                label={label}
                onTabChange={handleChange(index)}
                isActive={activeTabNumber === index}
                mode={mode}
                tabWidthPerc={tabWidthPerc}
                isDisabled={isDisabled}
                scrollable={scrollable}>
                {label}
              </Tab>
            );
          })}
        </StyledTabs>

        {tabPanelsCount > 0 && <>{getTabPanel(activeTabNumber)}</>}
      </>
    );
  },
);

export default Tabs;
